module.exports = __webpack_public_path__ + "img/full5-min.a1d90d59.png";